import { Component, OnInit } from '@angular/core';
import { monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts';
import { Piecharts } from '../models/piecharts';
import { AnalyticsService } from '../services/analytics.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  loadingClassificationChart = false;
  classificationChart = new Piecharts('pie');
  loadingBranchOfficeChart = false;
  branchOfficeChart = new Piecharts('pie');
  loadingAdvisorChart = false;
  branchAdvisorChart = new Piecharts('bar', false);

  constructor(private analitycService: AnalyticsService) {
    monkeyPatchChartJsTooltip();
    monkeyPatchChartJsLegend();

    this.loadingClassificationChart = true;
    this.analitycService.GetClassificationStatistics().subscribe(result => {
      this.classificationChart.pieChartColors = [
        {
          borderColor: 'black',
          backgroundColor: result.map((elem) => {
            return elem.color;
          })
        }
      ];
      this.classificationChart.pieChartLabels = result.map((elem) => {
        return elem.name;
      });
      this.classificationChart.pieChartData = result.map((elem) => {
        return elem.hectares;
      });
      this.loadingClassificationChart = false;
    });

    this.loadingBranchOfficeChart = true;
    this.analitycService.GetBranchOfficeChart().subscribe(data => {
      this.branchOfficeChart.pieChartLabels = data.map((elem) => {
        return elem.name;
      });
      this.branchOfficeChart.pieChartData = data.map((elem) => {
        return elem.hectares;
      });
      this.loadingBranchOfficeChart = false;
    });

    this.loadingAdvisorChart = true;
    this.analitycService.GetAdvisorChart().subscribe(data => {
      this.branchAdvisorChart.pieChartLabels = data.map((elem) => {
        return elem.name;
      });
      this.branchAdvisorChart.pieChartData = data.map((elem) => {
        return elem.hectares;
      });
      this.loadingAdvisorChart = false;
    });
  }

  ngOnInit(): void {
  }

}
